import { createContext, useEffect, useReducer, useContext } from "react";
import { LiferayService } from "../../../common/services/liferay/index";
import { ApplicationPropertiesContext } from "../../../common/context/ApplicationPropertiesProvider";
import { getSignedIdStatus,decode_utf8 } from "../../../common/utils/utilsFunc";

export const ReadingYourMeterContext = createContext();
export const ACTIONS = {
    SET_WEB_CONTENT_TEXT_INFO: "SET_WEB_CONTENT_TEXT_INFO",
    SET_CTA_CTO:"SET_CTA_CTO",
    SET_CTA_CTO_AUX:"SET_CTA_CTO_AUX",
    SET_RESPONSE_SERV_1:"SET_RESPONSE_SERV_1",
    SET_RESPONSE_SERV_2:"SET_RESPONSE_SERV_2",
    SET_DATA_FORM: "SET_DATA_FORM",
    SET_WEB_CONTENT_TERM_COND:"SET_WEB_CONTENT_TERM_COND",
    SET_DETAIL_CLIENT:"SET_DETAIL_CLIENT",
    SET_WEB_CONTENT_MEDIDOR:"SET_WEB_CONTENT_MEDIDOR",

};
const initialState = {
    webContentTextInfo: "",
    ctaCto: "",
    response_serv1:"",
    response_serv2:"",
    dataForm:"",
    webContentTermCond:"",
    detailClient: null,
    webContentMedidor:"",
    ctaCtoAux: ''

};
const ReadingYourMeterReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.SET_RESPONSE_SERV_2: {
      return {
        ...state,
        response_serv2: action.payload,
      };
    }
    case ACTIONS.SET_RESPONSE_SERV_1: {
      return {
        ...state,
        response_serv1: action.payload,
      };
    }
    case ACTIONS.SET_WEB_CONTENT_TERM_COND: {
      return {
        ...state,
        webContentTermCond: action.payload,
      };
    }
    case ACTIONS.SET_WEB_CONTENT_TEXT_INFO: {
      return {
        ...state,
        webContentTextInfo: action.payload,
      };
    }
    case ACTIONS.SET_CTA_CTO: {
      return {
        ...state,
        ctaCto: action.payload,
      };
    }
    case ACTIONS.SET_CTA_CTO_AUX: {
      return {
        ...state,
        ctaCtoAux: action.payload,
      };
    }
    case ACTIONS.SET_WEB_CONTENT_MEDIDOR: {
      return {
        ...state,
        webContentMedidor: action.payload,
      };
    }
    case ACTIONS.SET_DATA_FORM: {
      return {
        ...state,
        dataForm: action.payload,
      };
    }
    case ACTIONS.SET_DETAIL_CLIENT: {
      return {
          ...state,
          detailClient: action.payload
      };
    }
    default: {
      return state;
    }
  }
};
const ReadingYourMeterContextProvider = ({ children }) => {
  const properties = useContext(ApplicationPropertiesContext);

  const [state, dispatch] = useReducer(ReadingYourMeterReducer, initialState);
  

  useEffect(() => {
    if (state.dataForm) {
        LiferayService.sendDataForm(properties.base_url_api,state.dataForm,properties.url_ws_empresa,properties.codigo_empresa,getSignedIdStatus())
          .then((response) => {
            dispatch({
              payload: response,
              type: ACTIONS.SET_RESPONSE_SERV_2,
            });
          })
      }
  }, [state.dataForm]);
  
  useEffect(() => {
    if (state.ctaCto) {
        dispatch({
          payload: state.ctaCto,
          type: ACTIONS.SET_CTA_CTO_AUX,
        });
        LiferayService.validCtactoReg(properties.base_url_api,state.ctaCto,properties.url_ws_empresa,decode_utf8(properties.content_name_contribution_reading))
        .then((response) => {
            dispatch({
              payload: response,
              type: ACTIONS.SET_RESPONSE_SERV_1,
            });
            dispatch({
              payload: "",
              type: ACTIONS.SET_CTA_CTO,
            })
   
          if(response.code === 0){

            LiferayService.consultarDetalleCuentaContrato(properties.base_url_api,state.ctaCto, properties.url_ws_empresa, properties.codigo_empresa)
            .then((response) =>{
              dispatch({
                  payload: response,
                  type: ACTIONS.SET_DETAIL_CLIENT,
              });

            });
            
          } else {
            dispatch({
              payload: "",
              type: ACTIONS.SET_CTA_CTO,
            })
          }
        })
    }
  }, [state.ctaCto]);

  useEffect(() => {
    if (decode_utf8(properties.web_content_info_update_of_contact_information).trim()) {
        LiferayService.getWebContent(properties.base_url_api, decode_utf8(properties.web_content_info_update_of_contact_information).trim())
          .then((response) => {
            dispatch({
              payload: response,
              type: ACTIONS.SET_WEB_CONTENT_TEXT_INFO,
            });
          })
    }

    if(decode_utf8(properties.web_content_terms_conditions_contribution_reading).trim()) {
      LiferayService.getWebContent(properties.base_url_api, decode_utf8(properties.web_content_terms_conditions_contribution_reading).trim())
          .then((response) => {
            dispatch({
              payload: response,
              type: ACTIONS.SET_WEB_CONTENT_TERM_COND,
            });
          })
    }

    if(decode_utf8(properties.web_content_meter_reading_contribution_reading).trim()) {
      LiferayService.getWebContent(properties.base_url_api, decode_utf8(properties.web_content_meter_reading_contribution_reading).trim())
          .then((response) => {
            dispatch({
              payload: response,
              type: ACTIONS.SET_WEB_CONTENT_MEDIDOR,
            });
          })
    }
    
  }, []);

  return (
    <ReadingYourMeterContext.Provider value={[state, dispatch]}>
      {children}
    </ReadingYourMeterContext.Provider>
  );
};
export default ReadingYourMeterContextProvider;
